import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';

// material-ui
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

// project imports
import { usePermissions } from 'contexts/PermissionsContext';

// assets
import EditOutlined from '@ant-design/icons/EditOutlined';
import ProfileOutlined from '@ant-design/icons/ProfileOutlined';
import LogoutOutlined from '@ant-design/icons/LogoutOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import WalletOutlined from '@ant-design/icons/WalletOutlined';

interface Props {
  handleLogout: () => void;
}

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

export default function ProfileTab({ handleLogout }: Props) {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const { hasPermission } = usePermissions();

  const handleListItemClick = (event: React.MouseEvent<HTMLDivElement>, index: number, route: string = '') => {
    setSelectedIndex(index);

    if (route && route !== '') {
      navigate(route);
    }
  };

  useEffect(() => {
    const pathToIndex: { [key: string]: number } = {
      '/account/profile': 1,
      '/account/password': 3,
      '/account/team': 4,
      '/account/role': 5,
      '/account/organization': 6,
      '/account/settings': 7
    };

    setSelectedIndex(pathToIndex[location.pathname] ?? undefined);
  }, [location.pathname]);

  return (
    <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
      <ListItemButton
        selected={selectedIndex === 1}
        onClick={(event: React.MouseEvent<HTMLDivElement>) => handleListItemClick(event, 1, '/account/profile')}
      >
        <ListItemIcon>
          <UserOutlined />
        </ListItemIcon>
        <ListItemText primary="Profile" />
      </ListItemButton>

      <ListItemButton
        selected={selectedIndex === 3}
        onClick={(event: React.MouseEvent<HTMLDivElement>) => handleListItemClick(event, 3, '/account/password')}
      >
        <ListItemIcon>
          <ProfileOutlined />
        </ListItemIcon>
        <ListItemText primary="Password" />
      </ListItemButton>
      {hasPermission('canManageInvites') && (
        <ListItemButton
          selected={selectedIndex === 4}
          onClick={(event: React.MouseEvent<HTMLDivElement>) => handleListItemClick(event, 4, '/account/team')}
        >
          <ListItemIcon>
            <WalletOutlined />
          </ListItemIcon>
          <ListItemText primary="Team" />
        </ListItemButton>
      )}
      {hasPermission('canManageRoles') && (
        <ListItemButton
          selected={selectedIndex === 5}
          onClick={(event: React.MouseEvent<HTMLDivElement>) => handleListItemClick(event, 5, '/account/role')}
        >
          <ListItemIcon>
            <WalletOutlined />
          </ListItemIcon>
          <ListItemText primary="Role" />
        </ListItemButton>
      )}
      {hasPermission('canManageBilling') && (
        <ListItemButton
          selected={selectedIndex === 6}
          onClick={(event: React.MouseEvent<HTMLDivElement>) => handleListItemClick(event, 6, '/account/organization')}
        >
          <ListItemIcon>
            <WalletOutlined />
          </ListItemIcon>
          <ListItemText primary="Organization" />
        </ListItemButton>
      )}
      <ListItemButton selected={selectedIndex === 7} onClick={(event: React.MouseEvent<HTMLDivElement>) => handleListItemClick(event, 7, '/account/settings')}>
        <ListItemIcon>
          <WalletOutlined />
        </ListItemIcon>
        <ListItemText primary="Settings" />
      </ListItemButton>
      {/* <ListItemButton selected={selectedIndex === 7} onClick={handleLogout}>
        <ListItemIcon>
          <LogoutOutlined />
        </ListItemIcon>
        <ListItemText primary="Logout" />
      </ListItemButton> */}
    </List>
  );
}
